import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { colors, spacing, transitions } from '../../styles/tokens';
import './adminLayout.css';

const PHONE_LAYOUT_QUERY = '(max-width: 720px)';

export const AdminLayout: React.FC = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [phoneNavOpen, setPhoneNavOpen] = useState(false);

  const handleToggleSidebar = () => {
    const narrow =
      typeof window.matchMedia === 'function' && window.matchMedia(PHONE_LAYOUT_QUERY).matches;
    if (narrow) {
      setPhoneNavOpen((open) => !open);
      return;
    }
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div style={styles.container}>
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={handleToggleSidebar}
        panelClassName={phoneNavOpen ? 'app-sidebar app-sidebar-open' : 'app-sidebar'}
      />

      <div
        className="app-main"
        style={{
          ...styles.mainContent,
          marginLeft: sidebarCollapsed ? `calc(${spacing.xs} + ${spacing.sm} + ${spacing.sm})` : `calc(${spacing.lg} * 10)`,
        }}
      >
        <main className="app-content" style={styles.contentArea}>
          <button type="button" className="app-phone-menu" onClick={handleToggleSidebar}>
            {phoneNavOpen ? 'Close menu' : 'Menu'}
          </button>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    height: '100vh',
    minHeight: '100vh',
    overflow: 'hidden',
    backgroundColor: colors.background,
  },
  mainContent: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column' as const,
    overflow: 'hidden',
    transition: `margin-left ${transitions.base}`,
  },
  contentArea: {
    flex: 1,
    minHeight: 0,
    padding: spacing.lg,
    overflowY: 'auto' as const,
  },
};
